export class ShuffleBag<T> {
  private remaining: T[] = [];

  constructor(
    private readonly values: readonly T[],
    private readonly random: () => number = Math.random,
  ) {
    if (!values.length) throw new Error('A shuffle bag needs at least one value.');
  }

  next(previous?: T): T {
    if (!this.remaining.length) this.refill(previous);
    return this.remaining.shift()!;
  }

  private refill(previous?: T) {
    this.remaining = [...this.values];
    for (let index = this.remaining.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(this.random() * (index + 1));
      [this.remaining[index], this.remaining[swapIndex]] = [this.remaining[swapIndex], this.remaining[index]];
    }

    // Crossing a bag boundary must not make the final song of one cycle the
    // first song of the next cycle.
    if (this.remaining.length > 1 && Object.is(this.remaining[0], previous)) {
      const replacementIndex = 1 + Math.floor(this.random() * (this.remaining.length - 1));
      [this.remaining[0], this.remaining[replacementIndex]] = [this.remaining[replacementIndex], this.remaining[0]];
    }
  }
}
